<template>
  <v-container fluid id="NewWorkOrder">
    <!-- submitted dialog -->
    <v-dialog v-model="submitted" persistent width="500">
      <v-card>
        <v-card-text v-if="submitting">
          <h2 class="title mb-4 pt-4">Submitting Truck Service Request...</h2>
          <v-progress-linear
            indeterminate
            class="mb-0 mt-4"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text v-else class="text-center">
          <h2 class="title mb-4 pt-4">
            Truck Service Request successfully submitted!
          </h2>
          <v-btn color="primary" outlined to="/truck-requests/service"
            ><v-icon left>chevron_left</v-icon> Back to My Service
            Requests</v-btn
          >
          <div>
            <v-btn text @click="submitted = false" class="mt-4">close</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row wrap>
      <v-col cols="12" class="headline pl-0">
        <v-btn
          color="primary"
          class="mr-2 pa-0"
          small
          outlined
          text
          to="/truck-requests/service"
          style="margin-top:-3px"
          ><v-icon>chevron_left</v-icon></v-btn
        >
        New Truck Service Request
      </v-col>
    </v-row>

    <!-- JOB DETAILS -->
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-row>
        <v-col cols="12" sm="12" md="6" class="px-0">
          <v-card>
            <v-card-text class="px-1">
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12">
                    <v-select
                      :items="activeTrucks"
                      v-model="truck"
                      return-object
                      item-text="displayName"
                      hide-details
                      label="Select Truck"
                      width="100"
                      outlined
                      required
                      :rules="[(v) => !!v || 'Truck Selection Required']"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" xs="12">
                    <v-textarea
                      outlined
                      label="Describe the problem here."
                      v-model="notes"
                      required
                      :rules="[(v) => !!v || 'Description Required']"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" xs="12" class="pt-0">
                    <h4 class="mb-2">
                      Photos
                      <span class="caption grey--text">(optional)</span>
                    </h4>
                    <div class="d-flex" style="flex-wrap:wrap">
                      <input
                        accept="image/*"
                        type="file"
                        ref="file"
                        style="display: none"
                        multiple
                        @change="previewImages"
                      />
                      <v-btn
                        @click="$refs.file.click()"
                        style="width:100px;height:100px"
                        class="mr-2 mb-2"
                        :disabled="submitting"
                        ><v-icon large color="primary">add_a_photo</v-icon></v-btn
                      >
                      <v-card
                        style="width:100px;height:100px;position:relative"
                        class="mr-2 mb-2"
                        v-for="(photo, ix) in fileData"
                        :key="ix"
                      >
                        <img
                          :src="photo.imageUrl"
                          height="100"
                          width="100"
                          class="photo-preview"
                        />
                        <v-btn
                          icon
                          x-small
                          class="remove-photo"
                          :disabled="submitting"
                          @click="removeImage(ix)"
                        >
                          <v-icon small color="white">close</v-icon>
                        </v-btn>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="6">
          <v-btn
            class="mr-2"
            :disabled="!valid || submitting"
            block
            color="primary"
            @click="createTruckServiceRequest"
            >Submit Service Request
          </v-btn>
          <span class="red--text font-weight-bold" v-if="!valid"
            >* Missing some required fields above.</span
          >
        </v-col>
      </v-row>
    </v-form>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import fb from "@/main";
import utils from "@/helpers/utils";
import { mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      submitting: false,
      submitted: false,
      modal: false,
      snack: false,
      snackColor: "",
      snackText: "",
      trucks: [],
      truck: null,
      // form data
      notes: "",
      fileData: [],
    };
  },
  computed: {
    ...mapState(["user"]),
    activeTrucks: function() {
      return this.trucks.filter((t) => t.active);
    },
  },
  async created() {
    const truckRes = await fb.db.collection("trucks").get();
    truckRes.forEach((u) => {
      this.trucks.push({
        id: u.id,
        ...u.data(),
        displayName: utils.truckName(u.data()),
      });
    });
  },
  methods: {
    previewImages(event) {
      const files = [...event.target.files];
      files.forEach((file) => {
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener("load", () => {
          this.fileData.push({
            imageUrl: fr.result,
            image: file,
          });
        });
      });
      // clear the input so the same file can be picked again after removing it
      event.target.value = "";
    },
    removeImage(ix) {
      this.fileData.splice(ix, 1);
    },
    async uploadPhotos() {
      if (!this.fileData.length) {
        return [];
      }
      const snapshots = await Promise.all(
        this.fileData.map((file) => {
          const rando = Math.floor(Math.random() * 10000);
          const fileName = `${this.truck.id}/${Date.now()}-${rando}`;
          return fb.truckServiceStorage
            .ref()
            .child(fileName)
            .put(file.image);
        })
      );
      const downloadUrls = await Promise.all(
        snapshots.map(function(r) {
          return r.ref.getDownloadURL();
        })
      );
      return downloadUrls.map((url) => {
        return {
          url: url,
          uploadedBy: this.user,
          uploadDate: new Date(),
        };
      });
    },
    async createTruckServiceRequest() {
      try {
        if (this.$refs.form.validate()) {
          this.submitted = true;
          this.submitting = true;
          try {
            const photos = await this.uploadPhotos();
            await fb.db.runTransaction(async (transaction) => {
              // Get the metadata document and increment the count.
              const metaRef = fb.db.doc("metadata/truckService");
              const metaData = (await transaction.get(metaRef)).data() || {};

              const number = metaData.count + 1;

              transaction.update(metaRef, {
                count: number,
              });

              // Update the order document
              const requestRef = fb.db
                .collection("truckService")
                .doc(number.toString());

              transaction.set(requestRef, {
                orderedBy: this.user,
                orderDate: fb.timestamp,
                orderNumber: number.toString(),
                notes: this.notes,
                truck: this.truck.displayName,
                truckId: this.truck.id,
                status: "open",
                photos: photos,
              });
            });
            this.$refs.form.reset();
            this.fileData = [];
            this.submitting = false;
            this.submitted = true;
          } catch (error) {
            console.log(error);
            this.submitting = false;
            this.submitted = false;
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Error Submitting Truck Service Request!";
          }
        }
      } catch (error) {
        this.submitting = false;
        this.submitted = false;
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error Submitting Truck Service Request!";
      }
    },
  },
};
</script>
<style scoped>
.photo-preview {
  object-fit: cover;
  display: block;
}
.remove-photo {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.55);
}
</style>
